import { deepTransformDate, deepTransformTimestamp } from '../../utils/date';
import { BalanceJson, UserId } from '../Base';

type Plan<T = number> = {
  quantities: BalanceJson;
  refreshedAt: T;
  expiredAt: T;
};

type Allowances<T = number> = {
  userPlan: Plan<T>; // token
  creatorPlan: Plan<T>; // creationToken
};

export type AllowanceJson<T = number> = {
  userId: UserId;
  allowances: Allowances<T>;
};

export class Allowance implements AllowanceJson<Date> {
  userId!: UserId;
  allowances!: Allowances<Date>;

  constructor(allowance: AllowanceJson<Date | number>) {
    Object.assign(this, deepTransformTimestamp(allowance));
  }

  id(): string {
    return `${this.userId}`;
  }

  toJSON(): AllowanceJson {
    return deepTransformDate(this) as unknown as AllowanceJson;
  }
}
